import { render, staticRenderFns } from "./activity-groups-list.vue?vue&type=template&id=b22d575e&scoped=true"
import script from "./activity-groups-list.vue?vue&type=script&lang=js"
export * from "./activity-groups-list.vue?vue&type=script&lang=js"
import style0 from "./activity-groups-list.vue?vue&type=style&index=0&id=b22d575e&prod&scoped=true&lang=css"
import style1 from "./activity-groups-list.vue?vue&type=style&index=1&id=b22d575e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22d575e",
  null
  
)

export default component.exports